module.exports = __webpack_public_path__ + "static/media/exampleLogoHeader.1f766b81.jpg";